export default "__VITE_ASSET__XRKDz0DB__"